import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Small uppercase label rendered above the title. */
  eyebrow?: ReactNode;
  /** Breadcrumb trail — pass router `<Link>`s / `<a>`s separated however you like. */
  breadcrumbs?: ReactNode;
  /** Right-aligned actions (buttons, etc.). */
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  description,
  eyebrow,
  breadcrumbs,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <div className={cn('mb-6', className)}>
      {breadcrumbs && (
        <nav
          aria-label="Breadcrumb"
          className="text-ink-subtle mb-3 flex items-center gap-1.5 text-xs font-medium"
        >
          {breadcrumbs}
        </nav>
      )}
    </div>
  );
}
